// In production, we register a service worker to serve assets from local cache.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.

// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  ));

export default function register(onUpdateCallback) {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  // We are disabling this section of code because we are serving our JS and CSS assets from a CDN, and we are loading
  // the service worker directly from the same origin.
  // The URL constructor is available in all browsers that support SW.
  // const publicUrl = new URL(window.location);
  // if (publicUrl.origin !== window.location.origin) {
    // Our service worker won't work if REACT_APP_CANONICAL_ORIGIN is on a different origin
    // from what our page is served on. This might happen if a CDN is used to
    // serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
    // return;
  // }

  window.addEventListener('load', () => {
    // This will reload the page when the controller has changed.
    let swCalledUpdate = false;
    // Checking for this seems to be important for older browsers and devices,
    // such as Chrome 40 on Android 4.4.4
    if (typeof navigator.serviceWorker.addEventListener !== 'function') return;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (swCalledUpdate) return;
      swCalledUpdate = true;
      console.log('Controller changed...');
      onUpdateCallback();
    });

    const swUrl = '/service-worker.js';
    if (isLocalhost) {
      // This is running on localhost. Lets check if a service worker still exists or not.
      checkValidServiceWorker(swUrl);
    } else {
      // Is not local host. Just register service worker
      registerValidSw(swUrl);
    }
  });
}

function registerValidSw(swUrl) {
  // Some user agents fail at this point because it seems that
  // navigator.serviceWorker exists, but the register method is
  // undefined. Hence, we just skip service worker registration
  // in these cases.
  if (typeof navigator.serviceWorker.register !== 'function') return;

  navigator.serviceWorker
    .register(swUrl)
    .then(registration => {
      registration.onupdatefound = () => {
        console.log('Service worker found an update, please wait.');
        const installingWorker = registration.installing;
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // At this point, the old content will have been purged and
              // the fresh content will have been added to the cache.
              // It's the perfect time to display a "New content is
              // available; please refresh." message in your web app.
              console.log('New content is available; please refresh.');
            } else {
              // At this point, everything has been precached.
              // It's the perfect time to display a
              // "Content is cached for offline use." message.
              console.log('Content is cached for offline use.');
            }
          }
        };
      };
    })
    .catch(error => {
      console.error('Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl) {
  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl)
    .then(response => {
      // Ensure service worker exists, and that we really are getting a JS file.
      if (response.status === 404 ||
        response.headers.get('content-type').indexOf('javascript') === -1) {
        // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then(registration => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker found. Proceed as normal.
        registerValidSw(swUrl);
      }
    })
    .catch(() => {
      console.log('No internet connection found. App is running in offline mode.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    if (navigator.serviceWorker.ready == null) return;
    navigator.serviceWorker.ready.then(registration => {
      registration.unregister();
    });
  }
}
